import * as Yup from 'yup';
import * as React from 'react';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate, useLocation } from 'react-router-dom';
import { Icon } from '@iconify/react';

// material
import { Tooltip, Stack, Box, TextField, Typography, Modal, FormControl, FormLabel, InputLabel, IconButton, Select, MenuItem, Button, Grid, RadioGroup, Radio, Divider } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DataGrid, GridToolbar, GridPagination } from '@mui/x-data-grid';
import TimePicker from '@mui/lab/TimePicker';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Moment from 'moment';
import FormControlLabel from '@mui/material/FormControlLabel';
import CloseIcon from '@mui/icons-material/Close';

import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import { format } from 'date-fns';
import URLS from '../../../services/urls.service';
import AppCache from '../../../services/AppCache';
import { handleError } from '../../Common/Utils';
import ModalPopUp from '../../Common/ModalPopUp';
// -----------------------------------------------------------------------------------------------------


const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: '#fbe9e7', // Set the background color to #fbe9e7
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));


const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    maxHeight: '80vh',
    overflow: 'auto',
    borderRadius: '8px',
};
const CustomPagination = (props) => {
    return <GridPagination {...props} />;
};

export default function FillInstallationReportDetails() {
    const installationStatus = [
        { id: 1, Name: 'Completed' },
        { id: 2, Name: 'Cancelled' },
    ];
    const columns = [
        { field: 'activity', headerName: 'Activity', width: 100 },
        { field: 'StartTime', headerName: 'Start Time', width: 100 },
        { field: 'ServiceInMinute', headerName: 'Service In Min', width: 100 },
        { field: 'ServiceRemark', headerName: 'Service Remark', width: 100 }
    ];
    const location = useLocation();
    const navigate = useNavigate();
    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();

    const { enqueueSnackbar } = useSnackbar();

    const [fillInstallation, setFillInstallation] = useState(
        location.state?.fillInstallation || null
    );
    const [pageSize2, setPageSize2] = useState(25);
    const [userId, setUserId] = useState([]);
    const [openModalForCancel, setOpenModalCancel] = useState(false);
    const [serviceData, setServiceData] = useState([]);
    const [insStatusId, setInsStatusId] = useState('');
    const [effectiveFromValue, setEffectiveFromValue] = useState(new Date());
    const [activityData, setActivityData] = useState([]);
    const [activityDataValue, setActivityDataValue] = useState('');
    const [installationRemark, setInstallationRemark] = useState('');
    const [startTime, setStartTime] = useState('');
    const [serviceInMin, setServiceInMin] = useState('');
    const [serviceRemark, setServiceRemark] = useState('');
    const [services, setServices] = useState([]);
    const [showPreviousServiceData, setShowPreviousServiceData] = useState([]);
    const [showPreviousServiceModal, setShowPreviousServiceOpenModal] = useState(false);
    const [fieldValues, setFieldValues] = useState({});

    const fields = fillInstallation?.FillInstallationReportFilterData || [];
    const parentPanels = Array.isArray(fields) ? fields.filter(f => Number(f.ParentId) === 0) : [];
    const childFields = Array.isArray(fields) ? fields.filter(f => Number(f.ParentId) !== 0) : [];

    console.log("childFields", childFields, parentPanels)

    useEffect(() => {
        if (location.state?.fillInstallation) {
            setFillInstallation(location.state.fillInstallation);
        }
    }, [location.state]);

    useEffect(() => {
        setUserId(CurrentLoggedInUser.ExecutiveId);
    }, []);

    useEffect(() => {
        URLS.getActivityDD()
            .then((response) => {
                setActivityData(response.data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

    }, []);

    useEffect(() => {
        const data = fillInstallation?.ClientProductDistributorDetails?.[0];
        if (!data) return;

        setInsStatusId(data.InstallationStatus || '');
        setInstallationRemark(data.REMARK || '');
        setStartTime(data.StartTime || '');
        setServiceInMin(data.ServiceInMin || '');
        setServiceRemark(data.Remark || '');

        if (data.InstallationStatusUpdateDateTime) {
            setEffectiveFromValue(new Date(data.InstallationStatusUpdateDateTime));
        }

        // Prefill dynamic fields
        const initialValues = {};
        fields.forEach(f => {
            if (f.Answers) {
                initialValues[f.Sequence] = f.Answers;
            }
        });

        setFieldValues(initialValues);

    }, [fillInstallation]);

    console.log("fillInstallation detail", fillInstallation, fillInstallation?.fillInstallation);


    const fillInstallationNavigateClick = (serviceProvided) => {
        const serviceProvidedText = String(serviceProvided); // Ensure it's a string

        // Extract number at the end of the string
        const match = serviceProvidedText.match(/(\d+)$/);
        const installationReportId = match ? parseInt(match[1], 10) : null;
        if (!installationReportId) return;
        const payload = { InstallationReportQuestionnairesMasterId: installationReportId };
        URLS.fillInstallationReportFilterData(payload)
            .then((response) => {
                const jsonDataString = JSON.stringify(response?.data);

                const modifiedData = JSON.parse(jsonDataString);
                console.log("modifiedData", modifiedData)
                setFillInstallation(response.data);
            })
            .catch(error => {
                // On error
                console.error("")

            });
    }
    const showPreviousServiceColumn = [
        { field: "ServiceStartTime", headerName: "Date", flex: 0.3 },
        { field: "TotalServiceMinutes", headerName: "Duration", flex: 0.2 },
        { field: "ExecutiveName", headerName: "Executive", flex: 0.3 },
        {
            field: "ServiceProvided",
            headerName: "Service Remarks",
            flex: 1,
            renderCell: (params) => {
                const serviceProvided = params.row.ServiceProvided || "";
                const fileUrls = params.row.FileUrl || []; // Ensure it's always an array
                const fileNames = params.row.FileKeys || []; // Ensure it's always an array

                const downloadFile = (key) => {
                    const encodedKey = encodeURIComponent(key); // Encode special characters
                    URLS.downloadServiceFile(encodedKey, { responseType: "blob" }) // API call to get the file
                        .then((response) => {
                            const requestUrl = response.request.responseURL; // Get the actual file URL

                            const link = document.createElement("a");
                            link.href = requestUrl; // Directly use the response URL
                            link.setAttribute("download", key); // Set the filename
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);

                            console.log("File downloaded from:", requestUrl); // Log request URL for debugging
                        })
                        .catch(error => {
                            enqueueSnackbar("File not found.", { variant: "error" });
                        });
                };

                const matchText = "Installation report against Issue generated. please fill details online";
                const isInstallationReport = serviceProvided.includes(matchText);

                return (
                    <div>
                        {isInstallationReport ? (
                            <a
                                href="#"
                                style={{
                                    color: "blue",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                }}
                                onClick={() => fillInstallationNavigateClick(serviceProvided)}

                            >
                                {matchText}
                            </a>
                        ) : (
                            <div dangerouslySetInnerHTML={{ __html: serviceProvided }} />
                        )}
                        {fileUrls.map((fileUrl, index) => {
                            const extractedFileName = fileUrl.split("/").pop().split("?")[0];
                            const displayFileName = params.row.FileNames?.[index];

                            return (
                                <a
                                    key={index}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        downloadFile(fileNames[index]); // Use full key for downloading
                                    }}
                                    style={{
                                        color: "blue",
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                        display: "block",
                                    }}
                                    href="#"
                                >
                                    {displayFileName}
                                </a>
                            );
                        })}

                    </div>
                );
            },
        },

    ];

    const handleInsStatus = (id) => {
        setInsStatusId(id);

    };

    const message = {
        forCancel: 'Do you want to cancel ? ',
    };
    const forCancelConfirm = (value) => {
        if (value) {
            navigate('/dashboard/oa/fillintallationreport', { replace: true });

            setOpenModalCancel(false);
        }
        else {
            setOpenModalCancel(false);
        }
    };

    const handelCancelClick = () => {
        setOpenModalCancel(true);
    };

    const handleEffFrom = (newValue) => {
        setEffectiveFromValue(newValue)
    };

    const handleActivity = (id) => {
        setActivityDataValue(id);
    };

    const handleInstallationRemark = (e) => {
        setInstallationRemark(e.target.value);
    };
    const handleStartTime = (e) => {
        setStartTime(e.target.value);
    };
    const handleServiceInMin = (e) => {
        setServiceInMin(e.target.value);
    };
    const handleServiceRemark = (e) => {
        setServiceRemark(e.target.value);
    };

    // Handle changes in form elements
    const handleField = (id, value) => {
        setFieldValues((prevValues) => ({
            ...prevValues,
            [id]: value // Update only the specific field based on its id
        }));
    };
    const getActivityNameById = (id) => {
        console.log('Looking for activity with ID:', id); // Log the ID
        const activity = activityData.find(act => act.Id === Number(id));
        console.log('Found activity:', activity); // Log the activity found, if any
        return activity ? activity.Name : '';
    };

    const handleAddService = () => {
        if (!activityDataValue) {
            enqueueSnackbar("Please select an activity.");
            return;
        }
        if (!startTime) {
            enqueueSnackbar("Please select a start time.");
            return;
        }
        if (!serviceInMin) {
            enqueueSnackbar("Please enter service time in minutes.");
            return;
        }
        if (!serviceRemark) {
            enqueueSnackbar("Please enter a service remark.");
            return;
        }

        const details =
            fillInstallation?.ClientProductDistributorDetails?.[0];

        if (!details) return;

        const newService = {
            ClientId: details.ClientId,
            ProjectId: details.ProductId,
            SiteId: 0,
            ActivityId: activityDataValue,
            activity: getActivityNameById(activityDataValue),
            StartTime: startTime,
            ServiceInMinute: serviceInMin,
            ToTime: "",
            Date: new Date(),
            ServiceProvided: "",
            ServiceId: 0,
            Status: 0,
            PhoneNo: "",
            IsClientShow: 0,
            IssueSubstatusId: 0,
            IsIssueTrackerDashboardTrue: true,
            ServiceRemark: serviceRemark,
            UserID: userId,
            ServiceTypeId: activityDataValue,
            IssueId: details.IssueId,
        };

        setServices(prev => [...prev, newService]);
        setServiceData(prev => [...prev, newService]);

        // 🔹 Reset fields (keep types consistent)
        setActivityDataValue('');
        setStartTime('');
        setServiceInMin('');
        setServiceRemark('');
    };

    const handelShowPreviousOpenClick = () => {
        URLS.showPreviousServices(fillInstallation?.ClientProductDistributorDetails?.[0]?.IssueId)
            .then((response) => {
                setShowPreviousServiceData(response.data?.PreviousServices || []);

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        setShowPreviousServiceOpenModal(true);
    };

    const handelShowPreviousCancelClick = () => {
        setShowPreviousServiceOpenModal(false);
    };

    const renderField = (fields) => {
        const preSelectedValue = fields.Answers ?? "";

        switch (fields.ControlType) {

            case 'TextBox':
                return (
                    <TextField
                        label={fields.QuestionDescription}
                        fullWidth
                        size="small"
                        value={fieldValues[fields.Sequence] ?? preSelectedValue}
                        onChange={(e) => handleField(fields.Sequence, e.target.value)}
                    />
                );
            case 'DropDownList':
            case 'Dropdown': {
                if (!fields.DataValues?.trim()) {
                    return (
                        <FormControl fullWidth size="small">
                            <InputLabel>{fields.QuestionDescription}</InputLabel>
                            <Select value="">
                                <MenuItem value="">No Data Found</MenuItem>
                            </Select>
                        </FormControl>
                    );
                }

                let options = [];

                if (fields.DataValues.includes("Id:")) {
                    const regex = /Id:\s*(\d+),\s*Name:\s*([\w\s]+)/g;
                    options = [...fields.DataValues.matchAll(regex)].map(m => ({
                        id: Number(m[1]),
                        name: m[2]
                    }));
                } else {
                    const match = fields.DataValues.match(/\[([^[\]]+)\]/);
                    options = match
                        ? match[1].split('|').map(v => ({ id: v, name: v }))
                        : [];
                }

                return (
                    <FormControl fullWidth size="small">
                        <InputLabel>{fields.QuestionDescription}</InputLabel>
                        <Select
                            label={fields.QuestionDescription}
                            value={fieldValues[fields.Sequence] ?? preSelectedValue}
                            onChange={(e) => handleField(fields.Sequence, e.target.value)}
                        >
                            <MenuItem value="">Select</MenuItem>
                            {options.map(opt => (
                                <MenuItem key={opt.id} value={opt.id}>
                                    {opt.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                );
            }


            case 'Date Format':
                return (
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                            label={fields.QuestionDescription}
                            inputFormat="dd/MMM/yyyy"
                            value={fieldValues[fields.Sequence] ?? preSelectedValue}
                            onChange={(date) =>
                                handleField(
                                    fields.Sequence,
                                    date ? format(date, 'dd-MMM-yyyy') : ""
                                )
                            }
                            renderInput={(params) =>
                                <TextField fullWidth size="small" {...params} />
                            }
                        />
                    </LocalizationProvider>
                );

            case 'RadioButton': {
                if (!fields.DataValues) return null;

                const cleaned = fields.DataValues.replace(/[{}[\]]/g, '').split(',');
                const options = cleaned[4]?.split(':').filter(Boolean) || [];

                const selected =
                    fieldValues[fields.Sequence] ??
                    fields.Answers ??
                    cleaned[3] ??
                    "";

                if (!options.length) {
                    console.warn("No radio options for:", fields.QuestionDescription);
                    return null;
                }

                return (
                    <FormControl>
                        <FormLabel>{fields.QuestionDescription}</FormLabel>
                        <RadioGroup
                            row
                            value={selected}
                            onChange={(e) => handleField(fields.Sequence, e.target.value)}
                        >
                            {options.map((opt, i) => (
                                <FormControlLabel
                                    key={`${fields.QuestionId}-${i}`}
                                    value={opt}
                                    control={<Radio />}
                                    label={opt}
                                    sx={{ mr: 2 }}
                                />
                            ))}
                        </RadioGroup>
                    </FormControl>
                );
            }

            default:
                return null;
        }
    };

    const handleSaveDraft = async () => {
        const details = fillInstallation?.ClientProductDistributorDetails?.[0];
        if (!details) return;

        // Transform question answers
        const QuestionAnswersData = (fillInstallation?.FillInstallationReportFilterData || []).map(field => ({
            QuestionId: Number(field.QuestionId),
            Answer: fieldValues[field.Sequence] ?? field.Answers ?? ''
        }));

        // Get unique InstallationReportQuestionnairesMasterId
        const installationReportQuestionnairesMasterId = [...new Set(
            fillInstallation?.FillInstallationReportFilterData.map(f => f.InstallationReportQuestionnairesMasterId)
        )][0] || 0;

        // Format date
        const formattedDate = effectiveFromValue ? format(effectiveFromValue, 'dd-MMM-yyyy') : '';

        // Payload for draft
        const saveDraftPayload = {
            Id: 0,
            OAInstallationReportMasterId: details.OAInstallationReportMasterId,
            InstallationReportQuestionnairesMasterId: installationReportQuestionnairesMasterId,
            InstallationStatus: insStatusId,
            InstallationStatusUpdateDateTime: formattedDate,
            Remark: installationRemark || "",
            QuestionAnswers: QuestionAnswersData,
            Mode: 1,
            ClientId: details.ClientId,
            PONoDate: details.PONumber,
            LoggedinuserId: userId,
            InstallationDate: details.InstallationStatusUpdateDateTime,
            InstallationRemark: details.REMARK
        };

        const servicePayload = { saveservice: services };

        URLS.saveFillInstallationReport(saveDraftPayload)
            .then((response) => {
                if (response.status === 200) {
                    enqueueSnackbar("Record saved successfully", { variant: 'success' });
                }
            })
            .catch((error) => {
                enqueueSnackbar("Record not saved.", { variant: 'error' });
            });

        URLS.SaveFillInstallationData(servicePayload)
            .then((response) => {
                if (response.status === 200) {
                    enqueueSnackbar("Service record saved successfully", { variant: 'success' });

                    const issueId =
                        fillInstallation?.fillInstallation?.ClientProductDistributorDetails?.[0]?.IssueId;

                    if (issueId) {
                        URLS.showPreviousServices(issueId)
                            .then((prevResponse) => {
                                setShowPreviousServiceData(prevResponse.data?.PreviousServices || []);
                            })
                            .catch((error) => {
                                console.log("Error fetching previous services", error);
                            });
                    }
                }
            })
            .catch((error) => {
                //   enqueueSnackbar("Service record not saved.", { variant: 'error' });
                console.log("Error fetching previous services", error);

            });

        console.log("Draft Payload:", saveDraftPayload);
        console.log("Service Payload:", servicePayload);
    };

    const handlePrint = () => {
        const details = fillInstallation?.ClientProductDistributorDetails?.[0];
        if (!details) return;

        // Map QuestionAnswers
        const QuestionAnswersData = (fillInstallation?.FillInstallationReportFilterData || []).map(field => ({
            QuestionId: Number(field.QuestionId),
            Answer: fieldValues[field.Sequence] ?? field.Answers ?? '',
            ParentId: field.ParentId,
            QuestionDescription: field.QuestionDescription
        }));

        // Get unique InstallationReportQuestionnairesMasterId
        const installationReportQuestionnairesMasterId = [...new Set(
            fillInstallation?.FillInstallationReportFilterData.map(f => f.InstallationReportQuestionnairesMasterId)
        )][0] || 0;

        // Format date
        const formattedDate = effectiveFromValue ? format(effectiveFromValue, 'dd-MMM-yyyy') : '';

        // Build payload
        const printPayload = {
            Id: 0,
            OAInstallationReportMasterId: details.OAInstallationReportMasterId,
            InstallationReportQuestionnairesMasterId: installationReportQuestionnairesMasterId,
            InstallationStatus: insStatusId,
            InstallationDate: formattedDate,
            InstallationRemark: installationRemark || "",
            QuestionAnswers: QuestionAnswersData,
            Mode: 0, // 0 = Print, 1 = Save Draft
            ClientId: details.ClientId,
            ClientName: details.ClientName,
            ProductName: details.ProductName,
            PONoDate: details.PONumber,
            DistributorName: details.DistributorName,
            DistributorContact: details.DistributorContact,
            LoggedinuserId: userId,
        };

        // Call API
        URLS.generateFillInstallationPDF(printPayload)
            .then((response) => {
                const pdfPath = response?.data?.filepath;
                if (pdfPath) {
                    window.open(pdfPath, '_blank'); // Open PDF in new tab
                    enqueueSnackbar("PDF file generated successfully.", { variant: 'success' });
                }
            })
            .catch((error) => {
                console.error("Error generating PDF:", error);
                enqueueSnackbar("Error generating PDF.", { variant: 'error' });
            });

        console.log("Print Payload:", printPayload);
    };

    console.log("ServiceData", serviceData, services)

    const formik = useFormik({
        initialValues: {
            ProductId:
                fillInstallation?.ClientProductDistributorDetails?.[0]?.ProductId || "",
            SiteId:
                fillInstallation?.ClientProductDistributorDetails?.[0]?.IssueId || "",
            InstallationStatus: insStatusId || "",
            InstallationStatusUpdateDateTime: effectiveFromValue || "",
            Remark: installationRemark || "",
            Activity: activityDataValue || "",
            StartTime: startTime || "",
            ServiceInMin: serviceInMin || "",
            ServiceRemark: serviceRemark || ""
        },
        onSubmit: async (values) => {
            if (!insStatusId) {
                enqueueSnackbar("Please select installation status.");
                return;
            }

            const details = fillInstallation?.ClientProductDistributorDetails?.[0];
            if (!details) return;

            // Prepare QuestionAnswersData
            const QuestionAnswersData = (fillInstallation?.FillInstallationReportFilterData || []).map(field => ({
                QuestionId: Number(field.QuestionId),
                Answer: fieldValues[field.Sequence] ?? field.Answers ?? ''
            }));

            // Unique InstallationReportQuestionnairesMasterId
            const installationReportQuestionnairesMasterId = [...new Set(
                fillInstallation?.FillInstallationReportFilterData.map(f => f.InstallationReportQuestionnairesMasterId)
            )][0] || 0;

            // Format date
            const formattedDate = effectiveFromValue ? format(effectiveFromValue, 'dd-MMM-yyyy') : '';

            // Payload for report
            const payload = {
                Id: 0,
                OAInstallationReportMasterId: details.OAInstallationReportMasterId,
                InstallationReportQuestionnairesMasterId: installationReportQuestionnairesMasterId,
                InstallationStatus: insStatusId,
                InstallationStatusUpdateDateTime: formattedDate,
                Remark: installationRemark || "",
                QuestionAnswers: QuestionAnswersData,
                Mode: 0,
                ClientId: details.ClientId,
                PONoDate: details.PONumber,
                LoggedinuserId: userId,
                InstallationDate: details.InstallationStatusUpdateDateTime,
                InstallationRemark: details.REMARK
            };

            const servicePayload = { saveservice: services };
            URLS.saveFillInstallationReport(payload)
                .then((response) => {
                    if (response.status === 200) {
                        enqueueSnackbar("Record saved successfully", { variant: 'success' });
                        navigate('/dashboard/oa/fillintallationreport', { replace: true });
                    }
                })
                .catch((error) => {
                    enqueueSnackbar("Record not saved.", { variant: 'error' });
                });

            URLS.SaveFillInstallationData(servicePayload)
                .then((response) => {
                    if (response.status === 200) {
                        enqueueSnackbar("Service record saved successfully", { variant: 'success' });

                        const issueId =
                            fillInstallation?.fillInstallation?.ClientProductDistributorDetails?.[0]?.IssueId;

                        if (issueId) {
                            URLS.showPreviousServices(issueId)
                                .then((prevResponse) => {
                                    setShowPreviousServiceData(prevResponse.data?.PreviousServices || []);
                                })
                                .catch((error) => {
                                    console.log("Error fetching previous services", error);
                                });
                        }
                    }
                })
                .catch((error) => {
                    // enqueueSnackbar("Service record not saved.", { variant: 'error' });
                });
            console.log("Report Payload:", payload);
            console.log("Service Payload:", servicePayload);
        },
    });

    const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;

    return (
        <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit} >
                <Stack spacing={4}>
                    <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={null}>
                        <Grid container spacing={2} alignItems="center">
                            {fillInstallation?.ClientProductDistributorDetails?.length > 0 && (
                                <>
                                    <Grid item xs={12} style={{ textAlign: 'center' }}>
                                        <Typography
                                            variant="h6"
                                            style={{ borderBottom: '1px solid grey', display: 'inline-block' }}
                                        >
                                            <strong>{fillInstallation?.ClientProductDistributorDetails[0]?.ClientName}</strong>
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Stack direction="column" spacing={1} alignItems="flex-start">
                                            <Typography><strong>Product Name:</strong> {fillInstallation.ClientProductDistributorDetails[0]?.ProductName}</Typography>
                                            <Typography><strong>Distributor Name:</strong> {fillInstallation.ClientProductDistributorDetails[0]?.DistributorName || ''}</Typography>
                                            <Typography><strong>Distributor Contact:</strong> {fillInstallation.ClientProductDistributorDetails[0]?.DistributorContact || ''}</Typography>
                                            <Typography><strong>P.O. No. and Date:</strong> {fillInstallation.ClientProductDistributorDetails[0]?.PONumber || ''}</Typography>
                                        </Stack>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    </AccordionSummary>
                    {parentPanels.map(parent => (
                        <Accordion key={parent.QuestionId} defaultExpanded>
                            <AccordionSummary>
                                <Typography variant="subtitle1">
                                    {parent.QuestionDescription}
                                </Typography>
                            </AccordionSummary>

                            <AccordionDetails>
                                <Grid container spacing={2}>
                                    {childFields
                                        .filter(field =>
                                            (
                                                field.ParentId === Number(parent.QuestionId) &&
                                                field.InstallationReportQuestionnairesMasterId ===
                                                parent.InstallationReportQuestionnairesMasterId
                                            ) ||
                                            (
                                                field.ParentId === null &&
                                                field.Sequence === Number(parent.QuestionId) &&
                                                field.InstallationReportQuestionnairesMasterId ===
                                                parent.InstallationReportQuestionnairesMasterId
                                            )
                                        )
                                        .map((field) => (
                                            <Grid item xs={4} key={field.Sequence}>
                                                {renderField(field)}
                                            </Grid>
                                        ))
                                    }
                                </Grid>
                            </AccordionDetails>

                        </Accordion>
                    ))}

                    {childFields
                        .filter(field => field.ParentId === null)
                        .sort((a, b) => a.Sequence - b.Sequence)
                        .reduce((groups, field, index) => {
                            const groupIndex = Math.floor(index / 3); // 3 fields per row
                            if (!groups[groupIndex]) groups[groupIndex] = [];
                            groups[groupIndex].push(field);
                            return groups;
                        }, [])
                        .map((group, idx) => (
                            <Accordion key={`accordion-null-${idx}`} defaultExpanded>
                                <AccordionDetails>
                                    <Grid container spacing={2}>
                                        {group.map(field => (
                                            <Grid item xs={4} key={field.Sequence}>
                                                {renderField(field)}
                                            </Grid>
                                        ))}
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        ))
                    }
                    <Accordion>
                        <AccordionSummary expandIcon={null}>
                            <Grid container spacing={2}>
                                {/* Installation Status Select Field */}
                                <Grid item xs={4}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }}>
                                            Installation Status:
                                        </InputLabel>
                                        <Select
                                            label="Installation Status"
                                            size="small"
                                            value={insStatusId}
                                            MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                        backgroundColor: '#fbe9e7',
                                                        maxHeight: '200px',
                                                    },
                                                },
                                            }}
                                            onChange={(event) => handleInsStatus(event.target.value)}
                                        >
                                            {installationStatus.map((category) => (
                                                <MenuItem key={category.id} value={category.id}>
                                                    {category.Name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Installation Date Picker */}
                                <Grid item xs={4}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DesktopDatePicker
                                            label="Installation Date"
                                            inputFormat="dd/MMM/yyyy"
                                            value={effectiveFromValue}
                                            onChange={handleEffFrom}
                                            maxDate={new Date()}
                                            renderInput={(params) => <TextField fullWidth size="small" {...params} />}
                                        />
                                    </LocalizationProvider>
                                </Grid>

                                {/* Installation Remark Field */}
                                <Grid item xs={4}>
                                    <TextField
                                        label="Installation Remark"
                                        fullWidth
                                        size="small"
                                        onChange={handleInstallationRemark}
                                        value={installationRemark}
                                        multiline
                                    />
                                </Grid>
                            </Grid>
                        </AccordionSummary>

                    </Accordion>

                    <Grid container alignItems="flex-start">
                        <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column' }}>
                            <Accordion>
                                <AccordionSummary>
                                    <Typography variant="h6">Service Details</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth size="small">
                                                <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }}>
                                                    Activity
                                                </InputLabel>
                                                <Select
                                                    label="Activity"
                                                    size="small"
                                                    value={activityDataValue}
                                                    MenuProps={{
                                                        PaperProps: {
                                                            sx: {
                                                                backgroundColor: '#fbe9e7',
                                                                maxHeight: '200px',
                                                            },
                                                        },
                                                    }}
                                                    onChange={(event) => handleActivity(event.target.value)}
                                                >
                                                    {activityData.map((category) => (
                                                        <MenuItem key={category.Id} value={category.Id}>
                                                            {category.Name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <TextField
                                                size="small"
                                                label="Start Time"
                                                type="time"
                                                value={startTime}
                                                onChange={handleStartTime}
                                                inputLabelProps={{
                                                    shrink: true,
                                                }}
                                                inputProps={{
                                                    step: 300, // 5 min
                                                }}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <TextField
                                                size="small"
                                                label="Service in Min"
                                                type="number"
                                                value={serviceInMin}
                                                onChange={handleServiceInMin}
                                                fullWidth
                                            />
                                        </Grid>

                                        {/* Remark Field and Add Button */}
                                        <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <TextField
                                                label="Remark"
                                                fullWidth
                                                size="small"
                                                onChange={handleServiceRemark}
                                                value={serviceRemark}
                                                multiline
                                                style={{ width: '50%' }}
                                            />
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <Button sx={{ color: "white" }} size="medium" variant="contained" color="primary" onClick={handelShowPreviousOpenClick}>
                                                    Show Previous Service
                                                </Button>
                                                <Modal open={showPreviousServiceModal} onClose={handelShowPreviousCancelClick}>
                                                    <Box sx={modalStyle}>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                padding: '10px 16px',
                                                                borderBottom: '1px solid #E0E0E0',
                                                                backgroundColor: '#fff',
                                                                m: 0, // remove outer margins
                                                            }}
                                                        >
                                                            <Typography variant="h6" fontWeight='bold'>
                                                                Show Previous Service
                                                            </Typography>

                                                            <IconButton
                                                                onClick={handelShowPreviousCancelClick}
                                                                sx={{
                                                                    color: 'grey',
                                                                }}
                                                            >
                                                                <CloseIcon />
                                                            </IconButton>
                                                        </Box>

                                                        <Box sx={{ height: '62vh', width: '100%' }}>
                                                            <DataGrid
                                                                rows={showPreviousServiceData}
                                                                columns={showPreviousServiceColumn}
                                                                density="compact"
                                                                getRowId={(row) => row.id || showPreviousServiceData.indexOf(row)}
                                                                components={{ Toolbar: GridToolbar, Pagination: CustomPagination }}
                                                                pagination
                                                                paginationMode="client"
                                                                rowsPerPageOptions={[25, 50, 100]}
                                                                pageSize={pageSize2}
                                                                onPageSizeChange={(newPageSize) => setPageSize2(newPageSize)}
                                                                getRowHeight={() => 'auto'}
                                                                sx={{
                                                                    '& .MuiDataGrid-iconSeparator': { display: 'none' },
                                                                    '& .MuiDataGrid-row:nth-of-type(even)': {
                                                                        backgroundColor: 'white',
                                                                    },
                                                                    '& .MuiDataGrid-row:nth-of-type(odd)': {
                                                                        backgroundColor: '#f5f3f2',
                                                                        color: 'black',
                                                                    },
                                                                }}
                                                            />
                                                        </Box>
                                                    </Box>
                                                </Modal>

                                                <Tooltip title="Add New Service">
                                                    <Button onClick={handleAddService} variant="contained" size="small">
                                                        <Icon icon="ic:baseline-plus" width="25px" height="25px" />
                                                    </Button>
                                                </Tooltip>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Divider />

                                            <div style={{ height: '50vh', width: '100%', marginLeft: '20px', marginTop: '10px' }}>
                                                <DataGrid
                                                    rows={serviceData}
                                                    density="compact"
                                                    columns={columns}
                                                    getRowId={(row) => serviceData.indexOf(row)}
                                                    components={{
                                                        Toolbar: GridToolbar,
                                                    }}
                                                />
                                            </div>
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    </Grid>



                    {/* ----------------------------------------------------------------- */}

                    {/* <div style={{ height: '50vh', width: '100%', marginLeft: '20px', marginTop:'10px' }}> */}
                    {/*    <DataGrid rows={serviceData} density={'compact'} columns={columns} getRowId={(row) => serviceData.indexOf(row)} components={{ */}
                    {/*        Toolbar: GridToolbar, */}
                    {/*    }} /> */}
                    {/* </div> */}


                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="center" spacing={2}>

                        <LoadingButton
                            size="medium"
                            type="submit"
                            variant="contained"
                            sx={{ color: 'white' }}
                            loading={isSubmitting}
                        >
                            Save
                        </LoadingButton>
                        <Button
                            sx={{ color: 'white' }}
                            onClick={handleSaveDraft}
                            size="medium"
                            variant="contained"
                            color="primary"
                        >
                            Save Draft
                        </Button>
                        <Button
                            sx={{ color: 'white' }}
                            onClick={handlePrint}
                            size="medium"
                            variant="contained"
                            color="primary"
                        >
                            Print
                        </Button>
                        <Button
                            sx={{ color: 'white' }}
                            onClick={handelCancelClick}
                            size="medium"
                            variant="contained"
                            color="primary"
                        >
                            Back
                        </Button>

                    </Stack>
                </Stack>

            </Form>
            {openModalForCancel && <ModalPopUp openCloseValue={setOpenModalCancel} msg={message.forCancel} confirm={forCancelConfirm} />}

        </FormikProvider >
    );
}